import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import LockIcon from '../icons/LockIcon';

import BillsLabelIcon from '../icons/BillsLabelIcon';

import DoubleArrowIcon from './DoubleArrowIcon';

import styles from './PaymentTimeline.module.scss';
import PaymentTimelineCard from './PaymentTimelineCard';
import OnBookingClosed from './OnBookingClosed';

const noop = () => {};
const PaymentTimeline = ({
  listingCosts = {},
  pricing,
  downPaymentTimeInterval,
  onSelectDates = noop,
  unCollapseAll = false
}) => {
  const completedMarkerClasses = classNames(
    styles['payment-timeline__marker'],
    styles['payment-timeline__marker--completed']
  );

  const progressLineClasses = classNames(
    styles['payment-timeline__progress-line'],
    styles['payment-timeline__progress-line--completed']
  );

  const tags = [
    {
      label: trans('homecard.label.deposit.protected'),
      renderLeadingIcon: () => <LockIcon width="15" height="18" />,
      isSpaced: true
    },
    {
      label: trans('homecard.bills.some-included'),
      renderLeadingIcon: () => <BillsLabelIcon size="20" />,
      isSpaced: true
    }
  ];

  return (
    <div className={styles['payment-timeline']}>
      <section className={styles['payment-timeline__section']}>
        <div className={completedMarkerClasses}>
          <DoubleArrowIcon />
        </div>
        <div className={progressLineClasses}>
          <span />
        </div>
        <div>
          <h3 className={styles['payment-timeline__section-title']}>
            {trans('payment.timeline.section1.title')}
          </h3>
          <OnBookingClosed
            currencyCode={pricing?.currencyCode}
            pricing={pricing}
            costs={listingCosts?.onBookingClosed}
            downPaymentTimeInterval={downPaymentTimeInterval}
            onSelectDates={onSelectDates}
            collapsible={unCollapseAll}
            isCollapsed={!unCollapseAll}
          />
        </div>
      </section>
      <section className={styles['payment-timeline__section']}>
        <div className={styles['payment-timeline__marker']} />
        <div className={styles['payment-timeline__progress-line']} />
        <div>
          <h3 className={styles['payment-timeline__section-title']}>
            {trans('payment.timeline.section2.title')}
          </h3>
          <PaymentTimelineCard
            title="Total to pay per booking request"
            subtitle="Through Spotagome - One time - Card or Paypal"
            value="1003 €"
            collapsible
            isCollapsed={!unCollapseAll}
            tags={tags}
          >
            <p>The Content goes here</p>
          </PaymentTimelineCard>
        </div>
      </section>
    </div>
  );
};

PaymentTimeline.propTypes = {
  pricing: PropTypes.shape({}).isRequired,
  listingCosts: PropTypes.shape({}),
  downPaymentTimeInterval: PropTypes.shape({
    type: PropTypes.oneOf(['months', 'weeks']),
    value: PropTypes.number
  }).isRequired,
  onSelectDates: PropTypes.func,
  unCollapseAll: PropTypes.bool
};

export default PaymentTimeline;
